import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  sendState="notFound"
  
  constructor() { }

  ngOnInit() {
  }
    
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/not-found/not-found.component.ts